import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Brain, Rocket, Zap, CheckCircle, Globe } from "lucide-react";
import "./css/Strategy.css";

const Strategy = () => {
  const strategies = [
    {
      icon: <Brain size={40} />,
      label: "AI-powered",
      title: "Personalized Career Planning",
      description:
        "Each student gets a career path based on their interests, strengths, and goals.",
    },
    {
      icon: <Rocket size={40} />,
      title: "1-on-1 Mentorship from Industry Experts",
      description:
        "Students connect with real professionals for guidance, interview help, and career advice.",
    },
    {
      icon: <Zap size={40} />,
      label: "AI-powered",
      title: "Real-Time Progress Tracking ",
      description:
        "Parents/ Placement heads can monitor student growth and outcomes.",
    },
    {
      icon: <CheckCircle size={40} />,
      title: "Exclusive Internship & Job Opportunities",
      description:
        "Access to job openings and internship tie-ups curated by CLIF AI’s network.",
    },
    {
      icon: <Globe size={40} />,
      title: "Placement Readiness Programs",
      description:
        "Mock interviews, resume building, communication training, and confidence building",
    },
    {
      icon: <Globe size={40} />,
      title: "Campus Placement Dashboard",
      description:
        "Detailed  insights on student readiness, placement trends, recruiter feedback, and performance gaps. ",
    },
  ];

  return (
    <div className="strategy-section ">
      <Container>
        <h2 className="strategy-title text-center mb-5">
          Turn your campus into a future-ready, tech-enabled institution that
          stands out in placements and prestige
        </h2>
        <Row className="strategy-cards mb-5">
          {strategies.map((strategy, index) => (
            <Col md={2} key={index} className="mb-4">
              <div className="strategy-card text-center">
                <div className="strategy-icon">{strategy.icon}</div>
                {strategy.label && (
                  <span className="strategy-label">{strategy.label}</span>
                )}
                <h5 className="strategy-card-title">{strategy.title}</h5>
                <p className="strategy-card-description">
                  {strategy.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Strategy;
